import { Component, OnInit, ViewContainerRef } from '@angular/core';

import { AuthService, LoginInfo } from '../../_services/auth.service';
import { NgxSpinnerService } from 'ngx-spinner';
import { ActivatedRoute, Router } from '@angular/router';
import { DialogService } from '../../_services/dialog.service';
import { JwtClaims, JWTTokenService } from '../../_services/jwtToken.service';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MerchantService } from '../../_services/fundraising/merchant.service';
import { BaseService } from '../../_shared/base.service';

enum LoginMode {
  Merchant = 'merchant',
  Onboarding = 'onboarding',
  StripeSuccess = 'stripeSuccess',
  StripeFailure = 'stripeFailure',
  ResetPassword = 'resetPassword',
  ForgotPassword = 'forgotPassword'
}

@Component({
  selector: 'app-merchant-login',
  templateUrl: './merchant-login.component.html',
  styleUrls: ['./merchant-login.component.css'],
})
export class MerchantLoginComponent implements OnInit {
  model: LoginInfo = { email: '', password: ''};
  fpctries = 0;

  constructor(
    private authService: AuthService,
    private merchantService: MerchantService,
    private router: Router,
    private viewRef: ViewContainerRef,
    private spinner: NgxSpinnerService,
    private dialogService: DialogService,
    private route: ActivatedRoute,
    private jwtTokenService: JWTTokenService,
    private fb: FormBuilder) { }

  public merchantRegisterForm: FormGroup;
  public merchantLoginForm: FormGroup;
  public forgotPasswordForm: FormGroup;
  public passwordValid = true;
  public forgotPasswordSubmitted = false;
  public loading: Boolean = false;
  public loginMode = LoginMode.Merchant;

  public get loginModeType(): typeof LoginMode {
    return LoginMode; 
  }


  ngOnInit() {
    this.spinner.show();

    localStorage.setItem('portal-type', 'merchant');

    this.route.queryParams
      .subscribe(params => {
        const onboardingToken = params['t'];
        const stripeReturnStatus = params['s'];
        const forgotPasswordToken = params['f'];
        const stripeReturnToken = params['p'];

        if (onboardingToken) {

          this.jwtTokenService.setToken('onboarding', onboardingToken);

          const decodedToken = this.jwtTokenService.decodeToken('onboarding') as JwtClaims;

          if (!this.jwtTokenService.isTokenExpired('onboarding') && decodedToken) {

            if (decodedToken.role.includes('Onboarding') && decodedToken.role.includes('Merchant')) { 

              this.loginMode = LoginMode.Onboarding;

              this.merchantRegisterForm = this.fb.group({
                email: ['', [Validators.required, Validators.pattern(/^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/)]],
                newPassword1: ['',  [Validators.required, Validators.pattern(/^(?=.*[A-Za-z])(?=.*\d)(?=.*[@$!%*#.?&])[A-Za-z\d@$!.^%*#?&]{8,24}$/)]],
                newPassword2: ['', Validators.required]
              });

            }
          }
        } else if (stripeReturnStatus) {

          if (stripeReturnStatus === 'true') {

            this.loginMode = LoginMode.StripeSuccess;

            if (stripeReturnToken) {
              this.jwtTokenService.setToken('stripe-onboarding', stripeReturnToken);
              this.merchantService.activate().subscribe();
            }

          } else {
            this.loginMode = LoginMode.StripeFailure;
          }

        } else if (forgotPasswordToken) {

          this.jwtTokenService.setToken('forgotPassword', forgotPasswordToken);

          const decodedToken = this.jwtTokenService.decodeToken('forgotPassword') as JwtClaims;

          if (!this.jwtTokenService.isTokenExpired('forgotPassword') && decodedToken) {

            if (decodedToken.role.includes('ForgotPassword') && decodedToken.role.includes('Merchant')) { 

              this.loginMode = LoginMode.ResetPassword;

              this.merchantRegisterForm = this.fb.group({
                email: ['', [Validators.required, Validators.pattern(/^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/)]],
                newPassword1: ['',  [Validators.required, Validators.pattern(/^(?=.*[A-Za-z])(?=.*\d)(?=.*[@$!%*#.?&])[A-Za-z\d@$!.^%*#?&]{8,24}$/)]],
                newPassword2: ['', Validators.required]
              });

            }
          }

        } else {

          this.merchantLoginForm = this.fb.group({
            email: ['', [Validators.required, Validators.pattern(/^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/)]],
            password: ['', [Validators.required, Validators.pattern(/^(?=.*[A-Za-z])(?=.*\d)(?=.*[@$!%*#.?&])[A-Za-z\d@$!.^%*#?&]{8,24}$/)]]
          });

          this.forgotPasswordForm = this.fb.group({
            email: ['', [Validators.required, Validators.pattern(/^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/)]],
          });

          this.loginMode = LoginMode.Merchant;

        }
   
        this.spinner.hide();

      });
  }

  forgotPassword() { 
    this.spinner.show(); 
    this.merchantService.forgotPassword(this.forgotPasswordForm.controls.email.value.replace(/\s/g, ""))
      .subscribe(() => { 
        this.forgotPasswordSubmitted = true;
        this.spinner.hide();
      });
  }

  resetPassword() { 
    this.spinner.show(); 
    this.merchantService.resetPassword(
      this.merchantRegisterForm.controls.email.value.replace(/\s/g, ""), 
      this.merchantRegisterForm.controls.newPassword1.value)
        .subscribe(
          () => { 
          this.dialogService.alert(
            'Password Reset Successful', 
            'You can now login with your new password', 
            this.viewRef)
            .then(() => {
              this.merchantNav();
            });
          this.spinner.hide();
        },
          error => {
            this.spinner.hide();
            this.dialogService.alert('Something isn\'t right here...', error.error, this.viewRef)
              .then(() => {
                this.merchantNav();
              });
        });
  }

  submitMerchantRegistration() {
    if (!this.merchantRegisterForm.valid || this.merchantRegisterForm.controls.newPassword1.value != this.merchantRegisterForm.controls.newPassword2.value) {
      return;
    }

    this.spinner.show();
    this.merchantService.register(this.merchantRegisterForm.controls.email.value.replace(/\s/g, ""), this.merchantRegisterForm.controls.newPassword1.value)
      .subscribe(
        result => {
          this.spinner.hide();
          if (result) {
            this.dialogService.alert(
              'Account Registered!', 
              'You will be now be redirected to Stripe.com to securely complete your account profile', 
              this.viewRef)
            .then(() => {
              window.location.href = result.stripeOnboardingUrl;
            });
          }
        },
        error => {
          this.spinner.hide();
          this.dialogService.alert('Something isn\'t right here...', error.error, this.viewRef)
            .then(() => {
              this.merchantNav();
            });
        }
      );
  }


  merchantNav() {
    localStorage.setItem('portal-type', 'merchant');
    this.loginMode = LoginMode.Merchant;
    this.router.navigate(['/merchant-login']);
  }

  portalNav() {
    localStorage.setItem('portal-type', 'default');
    this.router.navigate(['/login']);
  }

  
  login() {
    this.spinner.show();
    this.merchantService.login(
      this.merchantLoginForm.controls.email.value.replace(/\s/g, ""),
      this.merchantLoginForm.controls.password.value)
    .subscribe(
      response => {
      if (response.stripeOnboardingUrl) {
        this.spinner.hide();
        this.dialogService.alert(
          'Please Complete Your Account Registration',
          'It looks like you haven\'t completed your Merchant Account registration yet. You will now be redirected to Stripe.com to securely complete your account profile',
          this.viewRef)
          .then(() => {
              window.location.href = response.stripeOnboardingUrl;
          });
        } else if (response.merchantToken) {

          this.jwtTokenService.setToken('merchant', response.merchantToken);

          // clear all cache when logged in
          BaseService.GlobalClearCache();

          const clientAppVersion = localStorage.getItem('Application-Version');
          const serverAppVersion = response.applicationVersion;
          if (serverAppVersion && clientAppVersion !== serverAppVersion) {
            localStorage.setItem('Application-Version', serverAppVersion);
            location.reload();
          }

          this.router.navigate(['/merchant']);
        }
      }, 
      error => {
        this.dialogService.alert('Invalid Credentials', 'Wrong username or password', this.viewRef);      
        this.spinner.hide();
      }
    );
  }

}


